import { render, staticRenderFns } from "./HobexCallback.vue?vue&type=template&id=3994b194"
import script from "./HobexCallback.vue?vue&type=script&lang=js"
export * from "./HobexCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports